export enum CommonApiErrorEnum {
    duplicateName = 'COM-001',    // This entity already exist
    badReference = 'COM-002',     // A reference to another object is invalid. It does not exist
    invalidModel = 'COM-003',     // Generic error when the model is invalid
    noIdOnNew = 'COM-004',        // Cannot provide an id for a new entity
    tooManyEntitiesRequested = 'COM-005',  // Too many entities requested
    invalidPage = 'COM-006',      // The page has to be greater than 0
    invalidBooleanQuery = 'COM-007',      // The boolean query in a search is invalid
    invalidReplyToEmail = 'COM-014' // The email is invalid
}
